import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function PaymentCancel() {
  return (
    <div className="grain min-h-screen" data-testid="payment-cancel-page">
      <Nav />
      <section className="pt-40 md:pt-52 pb-32 px-6 md:px-10">
        <div className="max-w-2xl mx-auto text-center glass shape-r p-10 md:p-14">
          <XCircle className="mx-auto text-fg/50 mb-6" size={48} />
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Checkout canceled.</h1>
          <p className="mt-5 text-fg/70 md:text-lg">No charge was made. Your date isn't held yet — you can reserve whenever you're ready.</p>
          <Link to="/drumtalk" data-testid="cancel-back-btn" className="inline-flex items-center gap-2 mt-8 shape-r bg-primary-c text-bg font-medium px-7 py-3.5 hover:opacity-90 transition-opacity"><ArrowLeft size={16} /> Back to DrumTalk</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
